import { FavoriteItemProps } from '@/components/ProfileModal/props';
import { useProfileModalVariant } from '@/hooks/theme/variants/useProfileModalVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import dynamic from 'next/dynamic';

const FavoriteCardTableContentV1 = dynamic(
  () => import('./V1').then(mod => mod.default),
  {
    ssr: true,
  },
);

const FavoriteCardTableContentV2 = dynamic(
  () => import('./V2').then(mod => mod.default),
  {
    ssr: true,
  },
);

export default function FavoriteCardTableContent(props: FavoriteItemProps) {
  const { version } = useProfileModalVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.UserProfileV1?.toString():
    default:
      return <FavoriteCardTableContentV1 {...props} />;
    case SettingLayoutComponentId.UserProfileV2?.toString():
      return <FavoriteCardTableContentV2 {...props} />;
  }
}
